import "./styles/visual-engine.css";
import "./styles/theme.css";
import { VisualEngineProvider, VisualEngineRoot } from "./visual-engine";
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <VisualEngineProvider>
      <VisualEngineRoot>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </VisualEngineRoot>
    </VisualEngineProvider>
  </React.StrictMode>
);
